module.exports = __webpack_public_path__ + "static/background-6a4cf4853c511fba1f5b33b38e31f7cd.jpg";